export const MAX_BUFFER_SIZE = 150;

export interface LatencyReading {
  ts: number;
  ms: number;
  timedOut: boolean;
}

export interface LatencyStats {
  current: number | null;
  avg: number;
  min: number;
  max: number;
  timeouts: number;
}

export function addReading(buffer: LatencyReading[], reading: LatencyReading): LatencyReading[] {
  const next = [...buffer, reading];
  return next.length > MAX_BUFFER_SIZE ? next.slice(next.length - MAX_BUFFER_SIZE) : next;
}

export function computeStats(buffer: LatencyReading[]): LatencyStats {
  if (buffer.length === 0) {
    return { current: null, avg: 0, min: 0, max: 0, timeouts: 0 };
  }

  const timeouts = buffer.filter(r => r.timedOut).length;
  const valid = buffer.filter(r => !r.timedOut);
  const last = buffer[buffer.length - 1];
  const current = last.timedOut ? null : last.ms;

  if (valid.length === 0) {
    return { current, avg: 0, min: 0, max: 0, timeouts };
  }

  const ms = valid.map(r => r.ms);
  const avg = Math.round(ms.reduce((a, b) => a + b, 0) / ms.length);
  const min = Math.min(...ms);
  const max = Math.max(...ms);

  return { current, avg, min, max, timeouts };
}
